import { MouseEventHandler } from "react";

export const handleCloseClick = (hideModal: () => void): MouseEventHandler => {
  const handler: MouseEventHandler = () => {
    hideModal();
  };

  return handler;
};
